import { useAccountMenuAction } from './actions/useAccountMenuAction'
import { useMainLayoutProps } from './actions/useMainLayoutProps'
import { useRenameThreadAction } from './actions/useRenameThreadAction'
import { useThreadMenuAction } from './actions/useThreadMenuAction'
import { useThreadShareActions } from './actions/useThreadShareActions'
import { useAppShellChatSendActions } from './useAppShellChatSendActions'

/**
 * Thread + send handlers and `mainLayoutProps` bundle.
 * @param {object} m — return value of `useAppShellChatModel`
 */
export function useAppShellChatActions(m) {
  const rename = useRenameThreadAction(m)
  const share = useThreadShareActions(m)
  const menu = useThreadMenuAction(m)
  const account = useAccountMenuAction()
  const send = useAppShellChatSendActions(m)
  const { mainLayoutProps } = useMainLayoutProps(m, {
    handleSendMessage: send.handleSendMessage,
    ...send.versions,
    handleSendEditVersion: send.handleSendEditVersion,
    handleRegenerateAssistantVersion: send.handleRegenerateAssistantVersion,
    handleMainAskBarPrefill: send.prefill.handleMainAskBarPrefill,
    handleConnectAppSend: send.connect.handleConnectAppSend,
    activeAgentQuestion: send.agentQuestion.activeAgentQuestion,
    onAgentQuestionConfirm: send.agentQuestion.onAgentQuestionConfirm,
  })
  return { ...rename, ...menu, ...account, ...share, mainLayoutProps }
}
